import { Link } from 'react-router-dom';
import { Phone, MessageCircle, Calendar } from 'lucide-react';
import { useSettings } from '@/lib/useSettings';

export const StickyContactBar = () => {
  const settings = useSettings();
  const contactInfo = settings.contact || {};
  return (
    <>
      <div
        className="fixed bottom-10 right-4 z-50 flex flex-col gap-2 items-end lg:hidden"
        data-testid="sticky-contact-bar"
      >
        <a
          href={`tel:${contactInfo.phone}`}
          className="flex items-center gap-2 px-5 py-3.5 rounded-full bg-white border border-[#E7E5E4] text-[#1F2937] text-base font-medium shadow-[0_8px_24px_-12px_rgba(0,0,0,0.18)] active:scale-95 transition-transform"
          data-testid="sticky-contact-call-button"
          aria-label="Ara"
        >
          <Phone size={20} />
          Ara
        </a>
        <a
          href={`https://wa.me/${contactInfo.whatsapp}`}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-2 px-5 py-3.5 rounded-full bg-[#1F6E7A] text-white text-base font-medium shadow-[0_10px_28px_-18px_rgba(0,0,0,0.25)] active:scale-95 transition-transform"
          data-testid="sticky-contact-whatsapp-button"
          aria-label="WhatsApp"
        >
          <MessageCircle size={20} />
          WhatsApp
        </a>
      </div>
    </>
  );
};

/* Desktop floating version */
export const DesktopFloatingContact = () => {
  const settings = useSettings();
  const contactInfo = settings.contact || {};
  return (
    <>
      <div
        className="hidden lg:flex fixed bottom-10 right-6 z-50 flex-col gap-2 items-end"
        data-testid="desktop-floating-contact"
      >
        <a
          href={`tel:${contactInfo.phone}`}
          className="flex items-center gap-2 px-5 py-3.5 rounded-full bg-white border border-[#E7E5E4] text-[#1F2937] text-base font-medium shadow-[0_8px_24px_-12px_rgba(0,0,0,0.18)] hover:scale-105 hover:-translate-y-0.5 active:scale-95 transition-transform"
          data-testid="desktop-call-button"
          aria-label="Telefon ile arayın"
        >
          <Phone size={20} />
          Ara
        </a>
        <a
          href={`https://wa.me/${contactInfo.whatsapp}`}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-2 px-5 py-3.5 rounded-full bg-[#1F6E7A] text-white text-base font-medium shadow-[0_10px_28px_-18px_rgba(0,0,0,0.25)] hover:scale-105 hover:-translate-y-0.5 active:scale-95 transition-transform"
          data-testid="desktop-whatsapp-button"
          aria-label="WhatsApp ile iletişime geçin"
        >
          <MessageCircle size={20} />
          WhatsApp
        </a>
      </div>
    </>
  );
};
